import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const DiagramaFinanzas = ({ pagos = [], filterMonth = "", chartType }) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!pagos.length) {
    return (
      <p className="text-gray-500 text-center">
        No hay datos disponibles para este año.
      </p>
    );
  }

  const data =
    filterMonth !== ""
      ? Array.from({ length: 31 }, (_, i) => {
          const day = i + 1;
          const pagosDelDia = pagos.filter(
            (pago) =>
              new Date(pago.fecha).getDate() === day &&
              new Date(pago.fecha).getMonth() + 1 === parseInt(filterMonth, 10)
          );
          const totalIngresos = pagosDelDia.reduce(
            (sum, pago) => sum + pago.monto,
            0
          );
          return { name: `Día ${day}`, Ingresos: totalIngresos };
        }).filter((item) => item.Ingresos > 0)
      : [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ].map((mes, index) => {
          const pagosDelMes = pagos.filter(
            (pago) => new Date(pago.fecha).getMonth() === index
          );
          const totalIngresos = pagosDelMes.reduce(
            (sum, pago) => sum + pago.monto,
            0
          );
          return { name: mes, Ingresos: totalIngresos };
        });

  const abreviarMes = (mes) => {
    const mesesAbreviados = {
      Enero: "Ene",
      Febrero: "Feb",
      Marzo: "Mar",
      Abril: "Abr",
      Mayo: "May",
      Junio: "Jun",
      Julio: "Jul",
      Agosto: "Ago",
      Septiembre: "Sept",
      Octubre: "Oct",
      Noviembre: "Nov",
      Diciembre: "Dic",
    };
    return mesesAbreviados[mes] || mes;
  };

  const formatNumber = (value) => value.toLocaleString("es-ES");

  const tickFormatter = (mes) => {
    if (screenWidth < 600) {
      return ""; // No mostrar nada en pantallas muy pequeñas
    }
    return screenWidth < 768 ? abreviarMes(mes) : mes;
  };

  return (
    <ResponsiveContainer width="100%" height={400}>
      {chartType === "bar" ? (
        <BarChart
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tickFormatter={tickFormatter} interval={0} />
          <YAxis tickFormatter={formatNumber} />
          <Tooltip formatter={(value) => `$${formatNumber(value)}`} />
          <Legend />
          <Bar dataKey="Ingresos" fill="#FB7D5B" radius={[20, 20, 0, 0]} />
        </BarChart>
      ) : (
        <LineChart
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 55,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tickFormatter={tickFormatter} interval={0} />
          <YAxis tickFormatter={formatNumber} />
          <Tooltip formatter={(value) => `$${formatNumber(value)}`} />
          <Legend />
          <Line
            type="monotone"
            dataKey="Ingresos"
            stroke="#FB7D5B"
            strokeWidth={4}
            dot={{ r: 4 }}
          />
        </LineChart>
      )}
    </ResponsiveContainer>
  );
};

export default DiagramaFinanzas;
